const ENDPOINT = new Map();

ENDPOINT.set('list', '/meetings');

export default ENDPOINT;
